<template>
	<div class="sk-widget sk-widget-perk">
		<img class="perk-image" src="/images/2k-coupon-banner.png" alt="Loyalty Perk Image" />
		<div>
			<h2>Earn with every order</h2>
			<div class="subtitle">
				{{ campaign.text }}
			</div>
			<UserLoyaltyProgress
				:progress="campaign.progress.count"
				:total="campaign.progress.goal"
			/>
		</div>
	</div>
</template>

<style scoped>
.sk-widget >>> .loyalty-progress > div {
	height: 15px;
	width: 15px;
}
</style>

<script>
import UserLoyaltyProgress from "@/components/common/UserLoyaltyProgress.vue"

export default {
	name: "LoyaltyWidget",
	components: {
		UserLoyaltyProgress
	},
	props: {
		campaign: Object
	}
}
</script>